import { DownloadOutlined } from '@ant-design/icons'
import { Alert, Button, Space } from 'antd'
import { useEffect } from 'react'

import { useDownloadProductsFileMutation } from '@Store/api/product'
import { showErrorMessage } from '@Utils/toast/toast-message'

interface TemplateDownloadProps {
  type: 'competitor' | 'product'
}

function TemplateDownload({ type }: TemplateDownloadProps): JSX.Element {
  const [
    downloadProductsFile,
    {
      isError: isDownloadError,
      error: downloadError,
      isLoading: isDownloadLoading,
    },
  ] = useDownloadProductsFileMutation()

  const onDownloadClick = async () => {
    await downloadProductsFile({ type })
  }

  useEffect(() => {
    if (isDownloadError) {
      showErrorMessage({
        message:
          (downloadError as any)?.data?.message ||
          'Failed to download the file.',
      })
    }
  }, [isDownloadError, downloadError])

  return (
    <Alert
      title={
        <p className="text-xs font-medium">
          <span className="text-sm">Download template</span> - Use this template
          to import{' '}
          {type === 'competitor' ? 'competitor URLs' : 'product details'} in
          bulk
        </p>
      }
      type="info"
      className="bg-gray-25 !border-gray-200 py-3 text-gray-600 text-sm"
      action={
        <Space>
          <Button
            className="flex-1 border border-solid rounded-lg !border-gray-300 hover:!border-gray-200 !text-gray-700 hover:!text-gray-900 !h-auto py-2"
            icon={<DownloadOutlined />}
            onClick={onDownloadClick}
            loading={isDownloadLoading}
          >
            Download
          </Button>
        </Space>
      }
      closable={false}
    />
  )
}

export default TemplateDownload
